const PrivacyPolicy = () => {
  return (
    <>
      <style jsx global>{`
        @charset "utf-8";

        #ch-plugin-entry {
          display: none;
        }

        #wrap {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          flex-direction: column;
        }
        #contents-wrap {
          flex: 1 1;
          display: flex;
          flex-direction: column;
          padding: 20px;
          max-width: 1200px;
          width: 100%;
          align-self: center;
        }
        #contents-wrap .page-title {
          flex: 0 0;
        }
        #contents-wrap .page-title h1 {
          font-size: 18px;
          color: #fe6b37;
          margin-bottom: 10px;
        }

        #contents-wrap .page-title p {
          margin-bottom: 10px;
        }

        #contents-wrap .term-text {
          flex: 1 1;
        }

        /* =================================================
          * Media Query
        ================================================= */
        @media only screen and (max-width: 768px) {
          #contents-wrap {
            padding: 20px;
          }
        }
      `}</style>
      <div id="wrap">
        <div id="contents-wrap" className="terms">
          <div className="page-title">
            <h1>마켓봄 개인정보처리방침</h1>
            <p>
              마켓봄은 서비스 이용자의 정보를 매우 중요하게 생각하며 아래와 같은
              개인정보 처리방침을 따릅니다.
            </p>
          </div>

          <div className="term-text">
            <iframe
              style={{
                height: "100%",
                width: "100%",
                border: "1px solid #ddd",
              }}
              src="https://asset.marketboro.com/term/marketbom/privacy.html"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
